import axios from '@/api/config';

const goodsClaimCode = {
  getGoodsClaimCodeById(data) {
    return axios.get(`${process.env.BASE_URL}/goodsClaimCode/getGoodsClaimCodeById/` + data, {});
  },
  getGoodsClaimCodeDetail(data) {
    return axios.get(`${process.env.BASE_URL}/goodsClaimCode/getGoodsClaimCodeDetail`, {params: data});
  },
  getGoodsClaimCode(data) {
    return axios.get(`${process.env.BASE_URL}/goodsClaimCode/getGoodsClaimCode`, {params: data});
  },
  getGoodsClaimCodeList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsClaimCode/getGoodsClaimCodeList`, {params: data});
  },
  getGoodsClaimCodeTree(data) {
    return axios.get(`${process.env.BASE_URL}/goodsClaimCode/getGoodsClaimCodeTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsClaimCode/pageList`, data);
  },
  addGoodsClaimCode(data) {
    return axios.post(`${process.env.BASE_URL}/goodsClaimCode/addGoodsClaimCode`, data);
  },
  updateGoodsClaimCode(data) {
    return axios.put(`${process.env.BASE_URL}/goodsClaimCode/updateGoodsClaimCode`, data);
  },
  deleteGoodsClaimCode(data) {
    return axios.delete(`${process.env.BASE_URL}/goodsClaimCode/deleteGoodsClaimCode`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/goodsClaimCode/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/goodsClaimCode/importData`, data);
  },
}

export default goodsClaimCode;



// WEBPACK FOOTER //
// ./src/api/goodsClaimCode.js